const httpMethods = {
  post: 'POST',
  get: 'GET',
  parch: 'PATCH'
}

export default httpMethods
